module.exports = __webpack_public_path__ + "img/1440.e00d19e6.jpg";